import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from "../market";

const WILDBERRIES_FAQ = [
  {
    title: "Что такое поведенческий фактор (ПФ) на Wildberries*?",
    isH3: true,
    text: (
      <p>
        <b>Поведенческий фактор (ПФ)</b> — это совокупность пользовательских действий, которые могут быть учтены маркетплейсом при формировании выдачи товаров. 
        <br />
        Среди них: просмотры карточки, взаимодействие с описанием, добавление в корзину или избранное, а также отзывы и оценки.
      </p>
    ),
  },
  {
    title: "Как может работать органическая выдача на Wildberries*?",
    isH3: true,
    text:
      <div>
        Алгоритмы Wildberries* могут учитывать ряд параметров при отображении товаров в поиске и рекомендациях:
        <br />
        <br />
        <ul>
          <li>Релевантность поисковому запросу: наличие ключевых слов в названии, описании и характеристиках</li>
          <li>История продаж и отзывов: количество заказов, оценок, комментариев</li>
          <li>Качество карточки: полнота описания, изображения, характеристики</li>
          <li>Активность покупателей: изучение карточки, добавление в корзину, в избранное</li>
          <li>Конкурентная цена и скидки: привлекательные условия способствуют интересу к товару</li>
        </ul>
      </div>
  },
  {
    title: "Как помогает Boostclick?",
    isH3: false,
    text:
      <div>
        Платформа Boostclick позволяет создавать задания с пользовательскими сценариями, в которых реальные исполнители взаимодействуют с карточками товаров.
        <br />
        <br />
        Это дает возможность:
        <br />
        <br />
        <ul>
          <li>протестировать, как пользователи находят и воспринимают карточку</li>
          <li>оценить вовлеченность (время на странице, добавления, интерес)</li>
          <li>получить отчет по итогам взаимодействия с карточкой</li>
          <li>выявить элементы, которые могут быть улучшены для повышения интереса к товару</li>
        </ul>
      </div>
    },
  {
    title: "Используются ли реальные пользователи?",
    isH3: true,
    text:
      <p>
        Да. Все действия на платформе выполняются реальными исполнителями — участниками, зарегистрированными на сторонних ресурсах и получившими инструкции через платформу.
        <br />
        <br />
        Сценарии ориентированы на имитацию обычного пользовательского опыта: от поиска товара до изучения описания.
      </p>
    },
  {
    title: "Есть ли гарантии или безопасность?",
    isH3: true,
    text:
      <div>
        Boostclick не предоставляет прямых гарантий ранжирования товаров.
        <br />
        Сервис предоставляет доступ к инструментам для проведения пользовательского тестирования и анализа вовлеченности, что может помочь в улучшении карточек и их восприятия.
        <br />
        <br />
        Для соблюдения принципов органичного взаимодействия:
        <br />
        <br />
        <ul>
          <li>исполнители не получают прямые ссылки на продвигаемые страницы</li>
          <li>задания строятся на основе ключевых фраз и категорий</li>
          <li>контроль осуществляется через отчеты и микрозадачи, привязанные к содержимому страницы</li>
        </ul>
      </div>
    },
  {
    title: "Как оплатить задания?",
    isH3: true,
    text:
      <p>
        Вы можете пополнить баланс личного кабинета на Boostclick через сервис Робокасса:
        <br />
        <br />
        Физическим лицам: от{'\u00A0—\u00A090\u00A0'}рублей
        <br />
        Юридическим лицам: от{'\u00A0—\u00A010 000\u00A0'}рублей
        <br />
        <br />
        Оплата списывается после выполнения задания и принятия отчета.
      </p>
  },
];

const STEP_TWO_TITLE_FAQ = (
  <p>
    Почему при добавлении одного действия в калькуляторе появляются
    дополнительные действия?
    <br />
    <br />
    Сервис формирует уникальные сценарии для каждого исполнителя, и каждый
    сценарий начинается для нового исполнителя с поиска товара по сделанному
    скриншоту вашей ссылки.
  </p>
);

const REVIEW_PRICE = 250;

const ACTIONS = [
  {
    type: "MAIN.FAVORITE",
    icon: "heart",
    iconHome: "home-heart",
    title: "Добавить товар в избранное",
    initialShare: 0.6,
    activityType: 'Избранное',
  },
  {
    type: "MAIN.BUSKET",
    icon: "busket",
    iconHome: "home-busket",
    title: "Добавить товар в корзину",
    initialShare: 0.4,
    activityType: 'Корзина',
  },

  {
    type: "ALWAYS.OPEN",
    icon: "open",
    iconHome: "home-open",
    title: "Открыть сайт или приложение WB",
    initialShare: 1,
  },
  {
    type: "ALWAYS.SEARCH",
    icon: "search",
    iconHome: "home-search",
    title: "Найти товар через поиск WB",
    initialShare: 1,
  },
  {
    type: 'ALWAYS.COMPETITORS',
    icon: "time",
    iconHome: "home-time",
    title: 'Быстро посмотреть конкурентов',
    initialShare: 1,
  },
  {
    type: "ALWAYS.CLICK",
    icon: "click",
    iconHome: "home-click",
    title: "Зайти на карточку товара",
    initialShare: 1.0,
  },

  {
    type: "EXTRA.MEDIA",
    icon: "eye",
    iconHome: "home-eye",
    title: "Посмотреть все фото и видео на карточке",
    initialShare: 0.6,
  },
  {
    type: "EXTRA.DESCRIPTION",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Прочитать полное описание товара",
    initialShare: 0.2,
  },
  {
    type: "EXTRA.GOODS",
    icon: "click",
    iconHome: "home-click",
    title: "Посмотреть другие товары продавца",
    initialShare: 0.1,
  },
  {
    type: "EXTRA.FEEDBACKS",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Прочитать отзывы на товар",
    initialShare: 0.1,
  },

  {
    type: "MAIN.LIKE",
    icon: "like",
    iconHome: "home-like",
    title: "Поставить положительную реакцию на отзыв",
    initialShare: 0,
    activityType: 'Лайк',
  },
  {
    type: "MAIN.DISLIKE",
    icon: "dislike",
    iconHome: "home-dislike",
    title: "Поставить отрицательную реакцию на отзыв",
    initialShare: 0,
    activityType: 'Дизлайк',
    hidden: true,
  },
  {
    type: "MAIN.APPEAL",
    icon: "dislike",
    iconHome: "home-dislike",
    title: "Пожаловаться на последний отзыв",
    initialShare: 0,
    activityType: 'Жалоба',
    hidden: true,
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Поведенческая активность",
    path: "/povedencheskie-faktory-na-wildberries",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.HIT,
  },
  {
    iconHome: "home-glasses",
    title: "Изучение товаров",
    path: "/povedencheskie-faktory-na-wildberries",
    target: '_self',
  },
  {
    iconHome: "home-star",
    title: "В избранное",
    path: "/povedencheskie-faktory-na-wildberries",
    target: '_self',
  },
  {
    iconHome: "home-busket",
    title: "Добавить в корзину",
    path: "/povedencheskie-faktory-na-wildberries",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти товар",
    path: "/povedencheskie-faktory-na-wildberries",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Переход по ссылке",
    path: "/povedencheskie-faktory-na-wildberries",
    target: '_self',
  },
  {
    iconHome: "home-gallery",
    title: "Все фото и видео",
    path: "/povedencheskie-faktory-na-wildberries",
    target: '_self',
  },
  {
    iconHome: "home-comparison",
    title: "Сравнение товаров",
    path: "/povedencheskie-faktory-na-wildberries",
    target: '_self',
  },
  {
    iconHome: "home-click",
    title: "Карточка товара",
    path: "/povedencheskie-faktory-na-wildberries",
    target: '_self',
  }
];

const STEP_PHRASE_2 = "Укажите информацию для поиска товара";

const WILDBERRIES_KEYWORDS = [
  'Wildberries', 'wildberries', 'Вайлдберриз', 'вайлдберриз', 'вб', 'wb'
];

class WildberriesClass extends Market {
  id = "wildberries";
  host = "wildberries.ru";
  hostsList = ["wildberries.ru", "wb.ru"];
  url = "https://wildberries.ru/";

  title = "Wildberries*";

  isMarketplace = true;

  icon = "wildberries";
  titlePlaces = "Wildberries*";
  statusForHomePage = MARKET_MODE_STATUS.POPULAR;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [
    { type: "Женщинам" },
    { type: "Обувь" },
    { type: "Детям" },
    { type: "Мужчинам" },
    { type: "Дом" },
    { type: "Красота" },
    { type: "Аксессуары" },
    { type: "Электроника" },
    { type: "Игрушки" },
    { type: "Мебель" },
    { type: "Продукты" },
    { type: "Цветы" },
    { type: "Бытовая техника" },
    { type: "Зоотовары" },
    { type: "Спорт" },
    { type: "Автотовары" },
    { type: "Транспортные средства" },
    { type: "Школа" },
    { type: "Книги" },
    { type: "Ювелирные изделия" },
    { type: "Для ремонта" },
    { type: "Сад и дача" },
    { type: "Здоровье" },
    { type: "Канцтовары" },
    { type: "Культурный код" },
    { type: "Цифровые товары" },
    { type: "Путешествия" },
  ];

  chainsPerDayNormal = 200 / 30;

  chainPrice = 24;
  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 10;

  reviewPrice = REVIEW_PRICE;

  chainsStep = 1;
  viewsStep = 10;

  keywords = WILDBERRIES_KEYWORDS;

  targetLinkComment = "Укажите тут адрес вашего товара на Wildberries*";
  targetLinkCommentShort = "Укажите ссылку товара";

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: "/povedencheskie-faktory-na-wildberries",
      rating: 0.8,
      title: "ПФ",
      navigateTitle: "Поведение и тест карточек товаров",
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,

      meta: {
        title: "Накрутка ПФ ЛЮДИ на Wildberries — просмотры, лайки | Boostclick",
        description: "Накрутка ПФ ЛЮДИ на Wildberries — просмотры, добавления.",
        canonical: '/povedencheskie-faktory-na-wildberries',
      },
      intro: {
        title: "Продвижение через ПФ на Wildberries*",
        comment: 'Через тестирование сценариев и микрозадачи от реальных пользователей:',
        points: [
          'Действия выполняются реальными пользователями с историей покупок',
          'Без использования автоматизированных или ботовых систем',
          'Подробные отчеты о взаимодействии с карточкой',
          'Оплата только после проверки и подтверждения результата',
          'Возможность анализа реакции на карточку по органическим запросам',
          'Помогает выявить потенциальные точки роста по вовлеченности (CTR, конверсия)',
        ],
      },
      howItWorks: [
        /* "Настройте параметры активности в соответствии с конкуренцией",
        "Укажите ссылку на товар для скриншота",
        "Укажите категорию, город и ключевые фразы из карточки товара",
        "После оплаты мы передадим исполнителю скриншот и параметры для поиска",
        "Проверьте ответы и активность, примите работу или отправьте на доработку", */
      ],
      stepPhrase1: "Настройка сценариев взаимодействия с карточкой товара на Wildberries*",
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: "Исследование пользовательского опыта на Wildberries*",
      titleFAQ: "Вопрос-ответ: тестирование пользовательского поведения на Wildberries*",
      faq: WILDBERRIES_FAQ,
      actions: (() => {
        return [
          ...ACTIONS.filter(
            (action) =>
              action.type !== "MAIN.REVIEW" && !action.type.startsWith("VIEW.")
          ),
          ...ACTIONS.filter((action) => action.type === "MAIN.REVIEW"),
        ];
      })(),
      notice: [
        'Платформа формирует индивидуальные задания с учетом ключевых поисковых запросов и параметров карточки. Каждый пользователь получает собственный сценарий, в рамках которого исследует карточку товара и взаимодействует с ней по заданным условиям.',
        'Примеры действий могут включать:',
        '– Поиск товара по заданному запросу',
        '– Изучение описания, характеристик и отзывов',
        '– Добавление товара в избранное или корзину (при необходимости)',
        'Это помогает оценить привлекательность карточки в органическом поиске и выявить факторы, влияющие на интерес и поведение пользователя.',
      ],
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action;
    return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на товар';
  invalidUrlStr = 'Укажите корректную ссылку на товар';
}

const Wildberries = new WildberriesClass();
export default Wildberries;
